import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { flatten, sortBy } from 'lodash';
import { AllowedOrgUnit, AllowedOrgUnits, OrgUnitPredicate, TagPredicate } from '../filter.type';

@Component({
    selector: 'org-unit-predicate',
    templateUrl: './org-unit-predicate.component.html',
    styleUrls: ['./org-unit-predicate.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslateModule,
        MatMenuModule
    ]
})
export class OrgUnitPredicateComponent implements OnChanges {

    other_values: AllowedOrgUnit[];

    @Input()
    orgUnits: AllowedOrgUnits[] = [];

    @Input()
    predicate: OrgUnitPredicate | TagPredicate;

    @Output()
    valueChange = new EventEmitter<{ value: AllowedOrgUnit, id: string }>();

    @Output()
    remove = new EventEmitter<string>();

    ngOnChanges() {
        if (this.orgUnits && this.predicate) {
            this.other_values =
                sortBy(flatten(this.orgUnits.filter(orgUnit => {
                    return orgUnit.type === this.predicate.org_unit_type;
                }).map(orgUnit => {
                    return orgUnit.values;
                })), ['name']);
        }
    }
    changeValue(value: AllowedOrgUnit, id: string) {
        this.valueChange.emit({ value, id });
    }
}